import React from 'react';
import { create } from 'zustand';

interface PageLayoutState {
  title: string | React.ReactNode | undefined;
  options: Record<string, unknown> | undefined;
  setTitle: (title: string | React.ReactNode | undefined) => void;
  setOptions: (options: Record<string, unknown> | undefined) => void;
  clear: () => void;
}

export const usePageLayoutStore = create<PageLayoutState>((set) => ({
  title: '',
  options: undefined,
  setTitle: (title: string | React.ReactNode | undefined) => {
    set({
      title,
    });
  },

  setOptions: (options: Record<string, unknown> | undefined) => {
    set((state) => {
      return {
        ...state,
        options,
      };
    });
  },

  clear: () => {
    set({
      title: undefined,
      options: undefined,
    });
  },
}));
